<template>
  <div class="sports_item">
    <!-- <Empty description="暂无数据"  /> -->
    <template v-if="subItemList.length">
      <div class="tabbody item">
        <!-- <div slot="title" class="sports_item_rule_img" @click="showRule=true">
            <VanImage
              src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220928/1664326651/213377.png"
              fit="cover"
              width="100%"
              height="100%"
            />
          </div> -->
          <PushUpsList  :pushUpsList="subItemList" v-on:goDetail="goDetail"></PushUpsList>
      </div>
        
    </template>
    <van-dialog
      v-model="showRule"
      class="sports_item_rule_dialog rule"
      :show-confirm-button="false"
      close-on-click-overlay
    >
      <van-icon
        name="close"
        style="position:fixed;right:10px;"
        size=".4rem"
        @click="showRule=false"
      />
      <div
        class="rule"
      >
        <!-- <div
          class="header"
          slot="title"
        >{{title}}</div> -->
        <div v-html="rule"></div>
      </div>
    </van-dialog>
    <Button
      round    
      @click="goDetail(subItemList[0])"
      class="mvbutton"
      style="width: 100%;"
      block
      v-if="enableActivity"
    >去看看</Button>
  </div>
</template>

<script>
import { Empty, Cell, CellGroup, Skeleton, Button, Image, Tag, Row } from "vant";
import "./item.less";
import PushUpsList from '@/views/Mwap/PushUpsList'
export default {
  computed: {
    buttonColor() {
      let detail = this.detail;
      return detail.tabstyle[0]["color"];
    }
  },
  components: {
    Empty,
    Cell,
    CellGroup,
    Skeleton,
    Button,
    VanImage: Image,
    Tag,
    PushUpsList
  },
  props: ["item", "detail", "sports_id"],
  watch: {
    item: {
      handler: "getItemInfo",
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      showRule: false,
      subItemList: [],
      title: "",
      rule: "",
      enableActivity: false,
      scoreType: 1,
      content: "",
      canjoin: "",
    };
  },
  methods: {
    goDetail(val) {
      this.$router.push({name:'sportsDetail',params:{sports_id:val.sports_id,item_sub_id:val.id}})
    },
    getItemInfo() {
      if(!this.item.id) return
      this.subItemList = [];
      this.rule = "";
      this.enableActivity = false
      this.$api.mwap.getItemSubs({ itemid: this.item.id }).then((res) => {
        this.subItemList = res.data.list;
        console.log(this.subItemList[0]['id'],'id')
        this.title = res.data.title;
        this.content = res.data.content;
        this.rule = res.data.rule;
        this.scoreType = res.data.score_type;
        this.canjoin = res.data.canjoin;
        if (+res.data.list.length === 1) {
          let {
            title,
            start_time,
            end_time,
            vote_start_time,
            vote_end_time,
          } = res.data.list[0];
          this.title = title;
          this.enableActivity = res.sys_time > start_time;
        }
      });
    },
  },
};
</script>
